import { render, staticRenderFns } from "./modal-details-sales-view.vue?vue&type=template&id=a5feb024&scoped=true"
import script from "./modal-details-sales-view.vue?vue&type=script&lang=js"
export * from "./modal-details-sales-view.vue?vue&type=script&lang=js"
import style0 from "./modal-details-sales-view.vue?vue&type=style&index=0&id=a5feb024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5feb024",
  null
  
)

export default component.exports